const restClient = fetch;

export default restClient;
